import { xor } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getOrgTermsContent } from '../../../../content/utils.js';
import { selectReadyProjects } from '../../../../modules/projects.js';
import { navigateToProjectReports } from '../../../links/index.jsx';

const mapStateToProps = (state) => {
  const projects = selectReadyProjects(state);

  return { projects };
};

ProjectsFilter.propTypes = {
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  selectedProjectIds: PropTypes.arrayOf(PropTypes.number),
};

ProjectsFilter.defaultProps = {
  projectIds: [],
  selectedProjectIds: [],
};

function ProjectsFilter({ projects, selectedProjectIds }) {
  const selectedCount = selectedProjectIds.length;

  const projectsByArchivedStatus = projects.reduce(
    (result, entity) => {
      if (entity.archived) {
        result.archived.push(entity);
      } else {
        result.active.push(entity);
      }
      return result;
    },
    { archived: [], active: [] }
  );

  const handleSelect = useCallback(
    (projectId) =>
      navigateToProjectReports({
        projectIds: projectId ? xor(selectedProjectIds, [projectId]) : [],
      }),
    [selectedProjectIds]
  );

  const renderMenuItem = useCallback(
    (project) => (
      <React.Fragment key={project.id}>
        <MenuItem
          active={selectedProjectIds.includes(project.id)}
          eventKey={project.id}
          onSelect={handleSelect}
        >
          {project.name}
        </MenuItem>
      </React.Fragment>
    ),
    [selectedProjectIds]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">
        {getOrgTermsContent('project')}
      </div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="projects-filter"
          className="btn-block"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          <MenuItem header>Active</MenuItem>
          {projectsByArchivedStatus.active.map(renderMenuItem)}
          <MenuItem divider />
          <MenuItem header>Archived</MenuItem>
          {projectsByArchivedStatus.archived.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default connect(mapStateToProps)(ProjectsFilter);
